<template>
  <div class="visitor-pricing__data table-periodic">
    <v-data-table
      class="data__table with-background"
      ref="table"
      :headers="headers"
      :items="data"
      :hide-default-header="isEmptyTable"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar class="v-data-table__status-bar" flat>
          <v-toolbar-title class="v-data-table__title">
            Periodic prices
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <template v-if="showCopyPaste">
            <v-btn
              class="pkmn-button-small mr-2"
              outlined
              color="primary"
              @click="$emit('copy')"
            >
              Copy
            </v-btn>
            <v-btn
              class="pkmn-button-small"
              color="primary"
              :loading="pasteLoading"
              :disabled="!canPaste || pasteLoading"
              @click="$emit('paste')"
            >
              Paste
            </v-btn>
          </template>
          <v-dialog
            v-model="dialog"
            :fullscreen="isMobile"
            width="80%"
            max-width="512px"
            @click:outside="close"
            v-if="!hideActions"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="pkmn-button-small ml-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                Add
              </v-btn>
            </template>
            <v-card class="form-dialog form-dialog--payout-id">
              <v-icon
                class="form-dialog__button form-dialog__button--close"
                @click="close"
              >
                mdi-close
              </v-icon>

              <h1 class="form-dialog__title">Set periodic prices</h1>

              <p class="form-dialog__subtitle">Example: daily ticket</p>

              <v-form ref="formPeriodic" class="data-table-periodic-form">
                <v-row class="form-row input-row">
                  <v-col>
                    <div class="text-input-label">Time period</div>
                    <v-row class="no-gutters">
                      <v-col cols="6">
                        <v-text-field
                          solo
                          flat
                          dense
                          background-color="#F6F6F6"
                          v-model="editedItem.time_period.value"
                          class="pkmn-input font-weight-bold pricing-time-value"
                          type="number"
                          min="1"
                          :rules="[rules.onlyPositive]"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          class="font-weight-bold pricing-time-class"
                          v-model="editedItem.time_period.unit"
                          :items="timeDayUnitOptions"
                          solo
                          flat
                          background-color="#F6F6F6"
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="form-row input-row">
                  <v-col>
                    <div class="text-input-label">Price</div>
                    <v-text-field
                      solo
                      flat
                      dense
                      background-color="#F6F6F6"
                      v-model="editedItem.price"
                      class="pkmn-input font-weight-bold"
                      type="number"
                      min="0"
                      :suffix="currentProductCurrencySymbol"
                      :rules="[rules.onlyPositive]"
                    />
                  </v-col>
                </v-row>

                <v-row class="form-dialog__button-wrap">
                  <v-col>
                    <v-btn
                      class="pkmn-button pkmn-button--has-border"
                      color="primary"
                      @click="addPrice"
                    >
                      Confirm
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogDelete"
            :fullscreen="isMobile"
            width="80%"
            max-width="512px"
            @click:outside="closeDelete"
          >
            <v-card class="form-dialog form-dialog--payout-id">
              <v-icon
                class="form-dialog__button form-dialog__button--close"
                @click="closeDelete"
              >
                mdi-close
              </v-icon>

              <h1 class="form-dialog__title">Delete periodic prices?</h1>

              <p class="form-dialog__subtitle">This action can't be undone.</p>

              <v-form>
                <v-row class="form-row input-row">
                  <v-col>
                    <div class="text-input-label">Time period</div>
                    <v-row class="no-gutters">
                      <v-col cols="6">
                        <v-text-field
                          solo
                          flat
                          dense
                          disabled
                          background-color="#F6F6F6"
                          v-model="editedItem.time_period.value"
                          class="pkmn-input pkmn-input--inline"
                          type="number"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.time_period.unit"
                          :items="timeDayUnitOptions"
                          solo
                          flat
                          disabled
                          background-color="#F6F6F6"
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="form-row input-row">
                  <v-col>
                    <div class="text-input-label">Price</div>
                    <v-text-field
                      solo
                      flat
                      dense
                      disabled
                      background-color="#F6F6F6"
                      v-model="editedItem.price"
                      class="pkmn-input"
                      type="number"
                      :suffix="currentProductCurrencySymbol"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row class="form-dialog__button-wrap pt-1">
                  <v-col cols="6" class="text-left">
                    <v-btn
                      class="pkmn-button"
                      outlined
                      color="danger"
                      @click="closeDelete"
                    >
                      Back
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      class="pkmn-button pkmn-button--delete pkmn-button--has-border"
                      color="danger"
                      @click="deleteItemConfirm"
                    >
                      Delete
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.id="{ item }">
        <div class="mobile-row__action" v-if="!hideActions">
          <div>
            <v-btn
              class="pkmn-button pkmn-button--no-padding data__action-button"
              text
              color="primary"
              @click="editSchedule(item)"
            >
              <img src="@/assets/button-edit.svg" />
            </v-btn>
            <v-btn
              class="pkmn-button pkmn-button--no-padding data__action-button"
              text
              color="warning"
              @click="deleteSchedule(item)"
            >
              <img src="@/assets/button-delete.svg" />
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:item.time_period="{ item }">
        {{ timePeriodString(item) }}
      </template>
      <template v-slot:item.price="{ item }">
        {{ priceString(item) }}
      </template>
      <template v-if="isEmptyTable" v-slot:body="">
        <div></div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import rules from '@/helpers/validation'
import { mapGetters } from 'vuex'
import { TimeEnum } from '@/enums'

export default {
  name: 'DataTablePeriodic',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    hideActions: {
      type: Boolean
    },
    showCopyPaste: { type: Boolean, default: false },
    canPaste: { type: Boolean, default: false },
    pasteLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      headers: [
        { text: 'Time period', value: 'time_period', width: 240 },
        { text: 'Price', value: 'price' },
        { text: '', value: 'id', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        time_period: {
          value: 1,
          unit: 'day'
        },
        price: 0
      },
      defaultItem: {
        time_period: {
          value: 1,
          unit: 'day'
        },
        price: 0
      },
      dialog: false,
      dialogDelete: false,
      rules: rules
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    }
  },

  computed: {
    ...mapGetters(['timeDayUnitOptions', 'currentProductCurrencySymbol']),
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    },
    isNewItem() {
      return this.editedIndex === -1
    },
    isEmptyTable() {
      return Object.keys(this.data).length === 0
    }
  },

  methods: {
    timePeriodString(item) {
      return `${item.time_period.value} ${TimeEnum[item.time_period.unit]}`
    },
    priceString(item) {
      return `${item.price} ${this.currentProductCurrencySymbol}`
    },
    editSchedule(item) {
      this.editedIndex = this.data.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteSchedule(item) {
      this.editedIndex = this.data.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    addPrice() {
      if (this.$refs.formPeriodic.validate()) {
        const newItem = this.editedItem
        if (this.isNewItem) {
          this.$emit('submit', newItem)
        } else {
          this.$emit('update', newItem)
        }
        this.close()
      }
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    deleteItemConfirm() {
      this.$emit('delete', this.editedItem.id)
      this.closeDelete()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.v-data-table__title {
  @include text-body;
  font-weight: 700;
  color: $text-color-dark;
}

.form-row {
  min-height: 60px;
  max-height: 70px;
}

.pkmn-button--delete {
  color: $color-white;
}

.pricing-time-value {
  margin-right: 12px;
}
.pricing-time-class {
  margin-left: 12px;
}
.form-dialog__button-wrap {
  margin-top: 24px !important;
}
</style>
<style lang="scss">
.data-table-periodic-form {
  .font-weight-bold input,
  .font-weight-bold .v-select__selection {
    font-weight: 900;
    line-height: 20px;
  }
}
</style>
